import { getAuthority } from '@utils/auth';

interface TokenExchangeResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
  scope: string;
  refresh_token: string;
}

export interface RefreshTokenResponse {
  access_token: string
  id_token: string
  expires_in: number
  token_type: string
  scope: string
  refresh_token: string
}

export async function exchangeToken(
  token: string,
): Promise<TokenExchangeResponse> {
  try {
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const urlencoded = new URLSearchParams();
    urlencoded.append('client_id', 'napsterai.companions.client');
    urlencoded.append(
      'grant_type',
      'urn:ietf:params:oauth:grant-type:token-exchange',
    );
    urlencoded.append('subject_token', token);
    urlencoded.append(
      'subject_token_type',
      'urn:ietf:params:oauth:token-type:access_token',
    );
    urlencoded.append(
      'requested_token_type',
      'urn:ietf:params:oauth:token-type:access_token',
    );
    urlencoded.append(
      'scope',
      'openid profile napsterai.companions.identity.main  offline_access',
    );

    const requestOptions: RequestInit = {
      method: 'POST',
      headers,
      body: urlencoded,
      redirect: 'follow' as RequestRedirect,
    };
    const response = await fetch(
      `${getAuthority()}connect/token`,
      requestOptions,
    );
    return response.json();
  } catch (error) {
    console.error('Error exchanging token:', error);
    throw error;
  }
}

export async function refreshToken(
  refreshToken: string,
): Promise<RefreshTokenResponse> {
  try {
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    })

    const urlencoded = new URLSearchParams()
    urlencoded.append('grant_type', 'refresh_token')
    urlencoded.append('refresh_token', refreshToken)
    urlencoded.append('client_id', 'napsterai.companions.client')

    const requestOptions: RequestInit = {
      method: 'POST',
      headers,
      body: urlencoded,
      redirect: 'follow' as RequestRedirect,
    }

    const response = await fetch(
      `${getAuthority()}connect/token`,
      requestOptions,
    )

    if (!response.ok) {
      throw new Error(
        `Token refresh failed: ${response.status} ${response.statusText}`,
      )
    }

    return response.json() as Promise<RefreshTokenResponse>
  } catch (error) {
    console.error('Error refreshing token:', error)
    throw error
  }
}
